__turbopack_context__.v({
  "icon": "CodeTextField-module-scss-module__CEAntW__icon",
  "timer": "CodeTextField-module-scss-module__CEAntW__timer",
});
